"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_ER_WAIT_TIMES_API_URL = void 0;
exports.coerceEdWaitTimesListPayload = coerceEdWaitTimesListPayload;
exports.describeEdWaitUpstreamPayload = describeEdWaitUpstreamPayload;
/**
 * Normalizes the ED wait-times upstream JSON payload into an array.
 * The Orlando Health DMZ endpoint sometimes returns JSON `false` (boolean) or other
 * non-array shapes when the service is gated or unavailable — callers must not call
 * `.map` on the raw body or the route will 500 and the client will show an error state.
 */
function coerceEdWaitTimesListPayload(data) {
    if (Array.isArray(data)) {
        return data;
    }
    if (data === false || data === null || data === undefined) {
        return [];
    }
    if (typeof data === "object" && data !== null) {
        const o = data;
        if ("d" in o) {
            const d = o.d;
            if (Array.isArray(d)) {
                return d;
            }
            if (typeof d === "string") {
                try {
                    const parsed = JSON.parse(d);
                    return Array.isArray(parsed) ? parsed : [];
                }
                catch {
                    return [];
                }
            }
        }
        if ("data" in o && Array.isArray(o.data)) {
            return o.data;
        }
        if ("value" in o && Array.isArray(o.value)) {
            return o.value;
        }
    }
    return [];
}
/** Default upstream URL; override with ER_WAIT_TIMES_API_URL when routing differs per env. */
exports.DEFAULT_ER_WAIT_TIMES_API_URL = "https://ohedwaittimesdmz.orlandohealth.com/ohedwaittimesdmz/api/EdWaitTimes/GetEdWaitWithFieldsForRightpointListAsync";
/**
 * Human-readable summary of the upstream JSON body for logs and optional API diagnostics.
 */
function describeEdWaitUpstreamPayload(raw) {
    if (raw === false) {
        return "boolean false (DMZ endpoint often returns this for callers outside the allowed network; not a JSON array)";
    }
    if (raw === true)
        return "boolean true";
    if (raw === null)
        return "null";
    if (raw === undefined)
        return "undefined";
    if (Array.isArray(raw)) {
        return `array with ${raw.length} item(s)`;
    }
    if (typeof raw === "object") {
        const keys = Object.keys(raw).slice(0, 12);
        return `object with keys: ${keys.join(", ") || "(none)"}`;
    }
    if (typeof raw === "string") {
        const t = raw.trim();
        return `string (${t.length} chars): ${t.slice(0, 120)}${t.length > 120 ? "…" : ""}`;
    }
    return String(typeof raw);
}
